// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class glblScheduleDescriptions_abstract extends SagaObject {
  static $t: string = 'SagaSchema.glblScheduleDescriptions';
  $t: string = 'SagaSchema.glblScheduleDescriptions';

  public static GetMembers(): string[] {
    return [
      'glblScheduleDescriptions_Uid',
      'glblScheduleDescriptions_Id',
      'glblScheduleDescriptions_Name',
      'glblScheduleDescriptions_Description'
    ].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return glblScheduleDescriptions_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public glblScheduleDescriptions_Uid: Guid = GuidTools.Empty;
  public glblScheduleDescriptions_Id: number = 0;
  public glblScheduleDescriptions_Name: string;
  public glblScheduleDescriptions_Description: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.glblScheduleDescriptions_Uid;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
